/* src/routes/index.svelte generated by Svelte v3.31.0 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	query_selector_all,
	safe_not_equal,
	space,
	text,
	transition_in,
	transition_out
} from "../../web_modules/svelte/internal.js";

import Content from "../../_components/Content.js";
import Hero from "../../_components/Hero.js";
import Btn from "../../_components/Btn.js";

function create_default_slot_1(ctx) {
	let t;

	return {
		c() {
			t = text("Contact me!");
		},
		l(nodes) {
			t = claim_text(nodes, "Contact me!");
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (25:0) <Content>
function create_default_slot(ctx) {
	let div1;
	let div0;
	let h3;
	let t0;
	let t1;
	let p;
	let t2;
	let t3;
	let a;
	let btn;
	let t4;
	let br0;
	let br1;
	let current;

	btn = new Btn({
			props: {
				btn: "filled",
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			div1 = element("div");
			div0 = element("div");
			h3 = element("h3");
			t0 = text("hi there!");
			t1 = space();
			p = element("p");
			t2 = text("Website currently under construction!");
			t3 = space();
			a = element("a");
			create_component(btn.$$.fragment);
			t4 = space();
			br0 = element("br");
			br1 = element("br");
			this.h();
		},
		l(nodes) {
			div1 = claim_element(nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			div0 = claim_element(div1_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			h3 = claim_element(div0_nodes, "H3", {});
			var h3_nodes = children(h3);
			t0 = claim_text(h3_nodes, "hi there!");
			h3_nodes.forEach(detach);
			t1 = claim_space(div0_nodes);
			p = claim_element(div0_nodes, "P", {});
			var p_nodes = children(p);
			t2 = claim_text(p_nodes, "Website currently under construction!");
			p_nodes.forEach(detach);
			t3 = claim_space(div0_nodes);
			a = claim_element(div0_nodes, "A", { href: true });
			var a_nodes = children(a);
			claim_component(btn.$$.fragment, a_nodes);
			a_nodes.forEach(detach);
			t4 = claim_space(div0_nodes);
			br0 = claim_element(div0_nodes, "BR", {});
			br1 = claim_element(div0_nodes, "BR", {});
			div0_nodes.forEach(detach);
			div1_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(a, "href", "/contact");
			attr(div0, "class", "content");
			attr(div1, "class", "index");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, div0);
			append(div0, h3);
			append(h3, t0);
			append(div0, t1);
			append(div0, p);
			append(p, t2);
			append(div0, t3);
			append(div0, a);
			mount_component(btn, a, null);
			append(div0, t4);
			append(div0, br0);
			append(div0, br1);
			current = true;
		},
		p(ctx, dirty) {
			const btn_changes = {};

			if (dirty & /*$$scope*/ 8) {
				btn_changes.$$scope = { dirty, ctx };
			}

			btn.$set(btn_changes);
		},
		i(local) {
			if (current) return;
			transition_in(btn.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(btn.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div1);
			destroy_component(btn);
		}
	};
}

function create_fragment(ctx) {
	let script;
	let t0;
	let t1;
	let hero;
	let t2;
	let content;
	let current;
	hero = new Hero({});

	content = new Content({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			script = element("script");
			t0 = text("(function(h,o,t,j,a,r){\n      h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};\n      h._hjSettings={hjid:2165595,hjsv:6};\n      a=o.getElementsByTagName('head')[0];\n      r=o.createElement('script');r.async=1;\n      r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;\n      a.appendChild(r);\n  })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');");
			t1 = space();
			create_component(hero.$$.fragment);
			t2 = space();
			create_component(content.$$.fragment);
			this.h();
		},
		l(nodes) {
			const head_nodes = query_selector_all("[data-svelte=\"svelte-v1ko4g\"]", document.head);
			script = claim_element(head_nodes, "SCRIPT", {});
			var script_nodes = children(script);
			t0 = claim_text(script_nodes, "(function(h,o,t,j,a,r){\n      h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};\n      h._hjSettings={hjid:2165595,hjsv:6};\n      a=o.getElementsByTagName('head')[0];\n      r=o.createElement('script');r.async=1;\n      r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;\n      a.appendChild(r);\n  })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');");
			script_nodes.forEach(detach);
			head_nodes.forEach(detach);
			t1 = claim_space(nodes);
			claim_component(hero.$$.fragment, nodes);
			t2 = claim_space(nodes);
			claim_component(content.$$.fragment, nodes);
			this.h();
		},
		h() {
			document.title = "Home • clp.is";
		},
		m(target, anchor) {
			append(document.head, script);
			append(script, t0);
			insert(target, t1, anchor);
			mount_component(hero, target, anchor);
			insert(target, t2, anchor);
			mount_component(content, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const content_changes = {};

			if (dirty & /*$$scope*/ 8) {
				content_changes.$$scope = { dirty, ctx };
			}

			content.$set(content_changes);
		},
		i(local) {
			if (current) return;
			transition_in(hero.$$.fragment, local);
			transition_in(content.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(hero.$$.fragment, local);
			transition_out(content.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			detach(script);
			if (detaching) detach(t1);
			destroy_component(hero, detaching);
			if (detaching) detach(t2);
			destroy_component(content, detaching);
		}
	};
}

let selected = "/";

function instance($$self, $$props, $$invalidate) {
	const title = "clp.is";
	const sub = "home";
	const heroVisible = true;
	return [title, sub, heroVisible];
}

class Routes extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { title: 0, sub: 1, heroVisible: 2 });
	}

	get title() {
		return this.$$.ctx[0];
	}

	get sub() {
		return this.$$.ctx[1];
	}

	get heroVisible() {
		return this.$$.ctx[2];
	}
}

export default Routes;
//# sourceMappingURL=index.js.map
